
import LocationMinus from "../../../assets/outline/LocationMinus.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function LocationMinusIcon({ className, dataTestid = "LocationMinusIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <LocationMinus data-testid={dataTestid} className={classes} {...rest} />
  );
}
